export default "__VITE_ASSET__BxPd3n95__"